module.exports = __webpack_public_path__ + "static/payment-2-20521aeeea2f707bfad8461f8f974e9f.png";